import styled, { css } from 'styled-components';

export const BackgroundContainerModal = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--background-modal);
  z-index: 1;
  display: flex;
  justify-content: center;
  padding: 5rem 0 0;
  color: var(--text-body);

  > div {
    display: flex;
    flex-direction: column;
    max-height: 200px;
    border-radius: 5px;
    width: 40%;
    background-color: var(--white);
    overflow-y: auto;
    z-index: 2;
  }
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid var(--black-light);

  > p {
    padding: 1rem;
    font-weight: 700;
  }

  > svg {
    margin-right: 1rem;
    cursor: pointer;
  }
`;

export const ContentModal = styled.div`
  padding: 1rem;
`;

export const FooterModal = styled.div`
  padding: 1rem;
  display: flex;
`;

export const Button = styled.button<{ default?: boolean }>`
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  max-width: 250px;
  height: 45px;
  color: var(--white);
  border-radius: 10px;
  transition: background-color 0.3s;
  text-transform: uppercase;

  ${(props) =>
    props.default &&
    css`
      background-color: var(--primary);
    `}

  ${(props) =>
    !props.default &&
    css`
      background-color: var(--error);
    `}

  & + button {
    margin-left: 0.5rem;
  }
`;
